import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Returns `true` if either the local feature flag ("enable-mcp-connections")
 * or the Statsig feature gate ("enable_mcp_connections") is enabled. The local
 * flag is the override the team can flip without touching Statsig; the gate
 * drives the tiered rollout.
 */
export const useEnableMcpConnections = (): boolean => {
  const featureFlag = useFeatureFlag("enable-mcp-connections");
  const featureGate = useGateValue("enable_mcp_connections");
  return featureFlag || featureGate;
};
